export function getPercentages<T extends { value: number }>(items: T[]) {
  type newT = T & {
    percRounded: number;
    cumulPercRounded: number;
    cumulPerc: number;
  };

  const total = items.reduce((res, curr) => curr.value + res, 0);

  return {
    total,
    parsedItems: items.reduce((acc, curr, idx) => {
      const perc = (curr.value / total) * 100;
      const cumulPerc = perc + (idx > 0 ? acc[idx - 1].cumulPerc : 0);
      const cumulPercRounded = Math.round(cumulPerc);
      const percRounded =
        cumulPercRounded - (idx > 0 ? acc[idx - 1].cumulPercRounded : 0);

      return [
        ...acc,
        {
          ...curr,
          perc,
          percRounded,
          cumulPerc,
          cumulPercRounded,
        },
      ];
    }, [] as newT[]),
  };
}
